// config.js

const backendUrl = 'https://mortgagestock-api-heroku-stg-174868516e68.herokuapp.com';

// const backendUrl = '';

export default backendUrl;
